/**
 * BudgetAnomalyService
 *
 * The anomaly review queue. Rows are written by the nightly sweep (deterministic detection —
 * robust z-score, duplicate suspicion, velocity jumps); this is where a human confirms or
 * dismisses them. Both verdicts are terminal: the sweep will not re-raise a reviewed finding.
 *
 * Route: api/budget-anomalies
 */
export class BudgetAnomalyService {
    constructor(http, config) {
        this.http = http;
        this.servicePath = config?.servicePath ?? BudgetAnomalyService.DEFAULT_SERVICE_PATH;
    }
    buildUrl(path) {
        const base = `${this.servicePath}/api/budget-anomalies`;
        const url = path ? `${base}/${path}` : base;
        return url.startsWith('/') ? url : '/' + url;
    }
    /** The queue. statusId 0 = open (the default view), 1 = confirmed, -2 = dismissed. */
    async getFiltered(params) {
        const response = await this.getFilteredRaw(params);
        return response.data ?? [];
    }
    getFilteredRaw(params) {
        const query = new URLSearchParams();
        if (params?.statusId != null)
            query.set('statusId', String(params.statusId));
        if (params?.budgetId != null)
            query.set('budgetId', String(params.budgetId));
        const qs = query.toString();
        // buildUrl() joins with a slash, which would yield ".../?a=1" — compose the query URL directly.
        const base = this.buildUrl();
        return this.http.get(qs ? `${base}?${qs}` : base);
    }
    /** Confirm: this is a real problem. */
    async confirm(anomalyId, body = {}) {
        const response = await this.confirmRaw(anomalyId, body);
        return response.data ?? false;
    }
    confirmRaw(anomalyId, body = {}) {
        return this.http.put(this.buildUrl(`${anomalyId}/confirm`), body);
    }
    /** Dismiss: reviewed, and the spend is legitimate. */
    async dismiss(anomalyId, body = {}) {
        const response = await this.dismissRaw(anomalyId, body);
        return response.data ?? false;
    }
    dismissRaw(anomalyId, body = {}) {
        return this.http.put(this.buildUrl(`${anomalyId}/dismiss`), body);
    }
}
BudgetAnomalyService.DEFAULT_SERVICE_PATH = 'budgets';
//# sourceMappingURL=BudgetAnomalyService.js.map